import { CompareActions } from 'features/products-compare';

export type CompareStatusMode = 'added' | 'removed' | 'error' | 'alert' | null;

type GetModeParams = {
  isError: boolean;
  isAlert: boolean;
  operation: CompareActions | null;
};

export const getCompareStatusMode = ({ isError, operation, isAlert }: GetModeParams): CompareStatusMode => {
  if (isError) {
    return 'error';
  }
  if (isAlert) {
    return 'alert';
  }

  switch (operation) {
    case CompareActions.ADD:
      return 'added';
    case CompareActions.DELETE:
    case CompareActions.DELETE_GROUP:
      return 'removed';
    default:
      return null;
  }
};

export const shouldShowCompareStatus = (
  operation: CompareActions | null,
  lastProductDelete: string | null,
  isLoading: boolean,
  mode: CompareStatusMode,
): boolean => {
  return Boolean(operation !== CompareActions.REQUEST && lastProductDelete && !isLoading && mode);
};
